import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import LoadingSkeleton from "../../../../loader/TableLoader";
import Pagination from "../../../../commanPage/pagination/Pagination";
import { NoItemsLeftInTable } from "../../../../../helpers/helpers";

function CatelogueAcceptedBy() {
  const totalNumberRow = 20;
  const loading = false;
  const isTablet = useMediaQuery({ query: "(max-width: 990px)" });
  const [currentPage, setCurrentPage] = useState(0);
  const navigate = useNavigate();

  return (
    <div className="">
      <span className={`valign-wrapper gap-1`}>
        <span
          className="material-icons-outlined pointer"
          onClick={() => navigate(-1)}
        >
          arrow_back
        </span>

        <h4>Catelogue Accepted list</h4>
      </span>
      <div className={`${!isTablet && "table-container-style"} full-width`}>
        <table
          className={`responsive-table centered ${
            isTablet ? "auction_table table-style" : "custom-table-style"
          } `}
        >
          <thead>
            <tr>
              <th>File Name</th>
              <th>File Type</th>
              <th>User Name</th>
              <th>Email Id</th>
              <th>Phone Number</th>
            </tr>
          </thead>
          <tbody>
         
          </tbody>
        </table>
        <NoItemsLeftInTable />
      </div>
    </div>
  );
}

export default CatelogueAcceptedBy;
